import React, { Component } from 'react';
import { connect } from 'react-redux';
import EditUser from './EditUser';
import Validators from '../../../../../common/utils/Validators';
import Constants from '../../../../../common/constants/Constants';

class EditUserContainer extends Component {
  constructor() {
    super();

    this.state = {
      selectedUser: {},
      roles: [],
      userPermissions: []
    };
  }

  componentWillReceiveProps(props) {
    const { selectedUser, roles, userPermissions } = props;
    this.setState({ selectedUser, roles, userPermissions });
  }

  _onRoleSelected = event => {
    let tempUser = this.state.selectedUser;
    tempUser.RoleEntity = this.state.roles.find(val => val.Name === event);
    tempUser.RoleEntityId = tempUser.RoleEntity.RoleEntityId;

    this.setState({ selectedUser: tempUser });
  };

  _onPermissionSelected = (event, isSelected) => {
    let tempUser = this.state.selectedUser;
    let touchedPermission = this.state.userPermissions.find(val => val.Name === event);

    if(touchedPermission !== undefined && touchedPermission !== '')
    {
      if(isSelected){
        tempUser.Permissions.push(touchedPermission);
      }
      else{
        let permission = tempUser.Permissions.find(p => p.Id === touchedPermission.Id)
        let index = tempUser.Permissions.indexOf(permission);
        tempUser.Permissions.splice(index, 1);
      }

      this.props.setUserPermissions(tempUser.Permissions);
    }
  };

  _handleChangeFor = (propertyName, value) => {
    let newItem = {
      [propertyName]: value
    };

    let tempUser = this.state.selectedUser;
    tempUser = this._setValidationErrorMessage(propertyName, value, tempUser);
    let editedUser = Object.assign(tempUser, newItem);
    this.setState({ selectedUser: editedUser });
  };

  _setValidationErrorMessage = (propertyName, value, user) => {
    let validationMessage = '';

    switch (propertyName) {
      case 'Username': {
        if (value !== '' && !Validators.validateStringBetweenRange(value, 3, 50)) {
          validationMessage =
            'Enter an alphanumeric value between 3 and 50 characters; for example: Username01';
        }
        user.UsernameErrorMessage = validationMessage;
        return user;
      }
      case 'Email': {
        if (value !== '' && !Validators.validateEmail(value)) {
          validationMessage = 'Enter an email address in the form of address@domain.com';
        } else if (
          value !== '' &&
          !Validators.validateEmailInDomainList(
            value,
            this.props.globalSettings[Constants.SETTING_KEYS.ALLOWED_USER_EMAIL_DOMAINS]
          )
        ) {
          validationMessage = 'Invalid email domain. Please use company email';
        }

        user.EmailErrorMessage = validationMessage;
        return user;
      }
      case 'AccountExpirationPeriod': {
        if (value !== '' && !Validators.validateIntegerNumberBetweenRange(value, 1, 3650)) {
          //maximum 10 years
          validationMessage = 'Enter an integer value from the interval 1 to 3650';
        }
        user.AccountExpirationErrorMessage = validationMessage;
        return user;
      }
      default:
        return user;
    }
  };

  render() {
    return (
      <EditUser
        {...this.props}
        onRoleSelected={this._onRoleSelected}
        onPermissionSelected={this._onPermissionSelected}
        handleChangeFor={this._handleChangeFor}
        globalSettings={this.props.globalSettings}
      />
    );
  }
}

const mapStateToProps = state => ({
  globalSettings: state.user ? state.user.Settings : undefined
});

export default connect(mapStateToProps)(EditUserContainer);
